import { render, staticRenderFns } from "./user-cashiers.vue?vue&type=template&id=fc32844a"
import script from "./user-cashiers.vue?vue&type=script&lang=js"
export * from "./user-cashiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/common/i18n/i18n-locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fsean%2FDocuments%2FEZMeals%2Fezmeals-store-management-ui%2Fsrc%2Fpages%2Fuser-cashiers.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports